


































  import { Component, Vue, Watch } from 'vue-property-decorator'
  import {getLocalItem,} from '@/utils'
  @Component({
    name:'GlobalMenu',
  })
export default class GlobalMenu extends Vue {
  private client:any =getLocalItem('client').roleNumber
  private selectedKeys: any[] = []
  private menuList: any[] = [

  ]
  private openKeys: any[] = []
  private defaultSelectedKeys: any[] = [this.$route.name]
 mounted(){
   if(this.client===1){
     this.menuList = [
        {
      name: '首页',
      path: '/home'
    },
    {
      name: '企业信息',
      path: '/msgenterprise'
    },
    {
      name: '节能监察',
      children: [
        {
          name: '书面监察',
          path:'/supervisionRecord/writtenSupervision',
        },
        {
          name: '现场监察',
          path:'/supervisionRecord/scenesupervision'
        }
      ]
    },
    {
      name:'系统管理',
      children:[
        {
          name:'文书模板管理',
          path:'/systemSeting/tempManage'
        }
      ]
    }
     ]
   } else {
     this.menuList = [
          {
      name: '首页',
      path: '/home'
    },
    {
      name: '企业信息',
      path: '/msgenterprise'
    },
    {
      name: '节能监察',
      children: [
        {
          name: '书面监察',
          path:'/supervisionRecord/writtenSupervision',
        },
        {
          name: '现场监察',
          path:'/supervisionRecord/scenesupervision'
        }
      ]
    },
    {
      name:'系统管理',
      children:[
        {
          name:'人员管理',
          path:'/SystemSeting/OrganizationManage'
        },{
          name:'文书模板管理',
          path:'/systemSeting/tempManage'
        }
      ]
    }
     ]
   }
 }
  private onOpenChange(Keys: any[]) {
    // 当菜单被展开时触发此处
    if (this.openKeys.length !== 0) {
      this.openKeys = [Keys[1]]
    } else {
      this.openKeys = [Keys[0]]
    }
  }
  private clickItem(obj: any) {
    if (!obj.children) {
      this.$router.push(obj.path)
    }
  }
}
